// extracted by mini-css-extract-plugin
module.exports = {"root":"DataPackInstances_root__302d3"};